import { render, staticRenderFns } from "./HistoryInformation.vue?vue&type=template&id=4574524b&scoped=true&"
import script from "./HistoryInformation.vue?vue&type=script&lang=js&"
export * from "./HistoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./HistoryInformation.vue?vue&type=style&index=0&id=4574524b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574524b",
  null
  
)

export default component.exports